import React from 'react';

const FullCard = ({ note, onClose }) => {
    return (
        <div className="fixed  inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-50">
            <div className="relative bg-white rounded-lg shadow-lg p-4 md:p-6 w-11/12 max-w-md md:max-w-lg lg:max-w-xl max-h-screen overflow-y-auto mx-4">
                <button onClick={onClose} className="absolute top-0 right-0 mt-4 mr-4 text-gray-600 hover:text-gray-800">
                    Close
                </button>
                <h2 className="text-lg md:text-xl lg:text-2xl font-bold mb-4">{note.title}</h2>
                <p className="text-gray-500 mb-4">{note.date}</p>
                <p className="mb-4">{note.content}</p>
                <div>
                    {note.tags.map(tag => (
                        <span key={tag} className="inline-block bg-blue-200 text-blue-800 rounded-full px-2 py-1 text-xs font-semibold mr-2">{tag}</span>
                    ))}
                </div>
            </div>
        </div>
    );
};




export default FullCard;
